import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=738baf3c&"
import script from "./metadata.vue?vue&type=script&lang=js&"
export * from "./metadata.vue?vue&type=script&lang=js&"
import style0 from "./metadata.vue?vue&type=style&index=0&id=738baf3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports